module.exports = __webpack_public_path__ + "img/mx.3ec0ef90.svg";